__turbopack_context__.v({
  "Breadcumb": "Breadcumb-module___lHAJa__Breadcumb",
  "icon": "Breadcumb-module___lHAJa__icon",
  "item": "Breadcumb-module___lHAJa__item",
  "name": "Breadcumb-module___lHAJa__name",
});
